import type { AnalysisStatus, CreativeKind } from './analysis.types'

export type LabellingRunType = 'initial' | 'relabel' | 'manual'

export type ManualOverridePolicy = 'keep' | 'override'

/** Raw status returned by REST run and label-schema summary endpoints. */
export type LabellingStatus =
  'pending' | 'running' | 'cancel_requested' | 'completed' | 'failed' | 'cancelled'

export const LABELLING_ACTIVE_STATUSES = [
  'pending',
  'running',
  'cancel_requested',
] as const satisfies readonly LabellingStatus[]

export const LABELLING_TERMINAL_STATUSES = [
  'completed',
  'failed',
  'cancelled',
] as const satisfies readonly LabellingStatus[]

export type InsightStatus = 'queued' | 'running' | 'completed' | 'failed' | 'partial'

export interface CreativeLabellingRun {
  id: number
  workspace_id: number
  run_type: LabellingRunType
  scope: CreativeKind
  status: LabellingStatus
  display_status: AnalysisStatus
  processed_count: number
  total_count: number
  failed_count: number
  skipped_count: number
  eta_seconds: number | null
  failed_sample: Array<Record<string, unknown>>
  schema_diff: Record<string, unknown>
  triggered_by: number | null
  celery_task_id: string | null
  error_message: string | null
  created_at: string
  started_at: string | null
  finished_at: string | null
  updated_at: string
}

export interface LabellingRunListResponse {
  runs: CreativeLabellingRun[]
  active_run: CreativeLabellingRun | null
}

export interface CreativeLabellingAnalysisProgress {
  id: number
  status: AnalysisStatus
  insight_status: InsightStatus | null
  combination_insight_status: InsightStatus | null
}

/** One published SSE shape for every run type; run_type is the only discriminator. */
export interface CreativeLabellingProgressEvent {
  event: 'creative_labelling_progress'
  workspace_id: number
  ts: number
  ts_iso: string
  account_id: number | null
  event_id: string
  id: number
  run_type: LabellingRunType
  scope: CreativeKind
  /** Authoritative status follows run_type: analysis vocabulary or relabel vocabulary. */
  status: AnalysisStatus | LabellingStatus
  labelled_count: number
  processed_count: number
  total_count: number
  skipped_count: number
  failed_count: number
  eta_seconds: number | null
  started_at: string | null
  finished_at: string | null
  error_message: string | null
  analyses: CreativeLabellingAnalysisProgress[]
}

export type LabellingFrameKind = 'analysis' | 'relabel'
